import React, { useCallback, useEffect } from 'react'
import Logo from './Logo'
import { useDispatch, useSelector } from 'react-redux'
import ProgressBar from "../ContentPlayerPage/Quiz/ProgressBar"
import { useState } from 'react'
import SearchBar from './SearchBar'
import { useDebounce } from '../../hooks/useDebounce'
import { getGoalsAndRoles, onboardingSearch } from '../../redux/actions/userActivity'
import { getAllCourses } from '../../redux/actions/courses'
import SingleList from './SingleList'
import Skeleton from './Skeleton'
import { getAllSkills } from '../../redux/actions/skills'
import { checkUserAccess, setOnboardingData } from '../../redux/actions/authentication'
import { faArrowLeft, faChevronRight, faCloudSun, faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ClipLoader, SyncLoader } from 'react-spinners'
import { RESET_PERSONALISE_ANALYSIS, RESET_PERSONALISE_MCQ_ANSWER, RESET_PERSONALISE_QUESTIONS, SET_CUSTOM_SKILL_SELECTED, SET_PERSONALISE_COURSE_NAME } from '../../redux/actions/types'
import { Mixpanel } from "../../config/Mixpanel"
import Constants from '../../common/constants'
import useWindowSize from '../../hooks/useWindowSize'
import PersonalisedOddUserVariant2 from './PersonalisedOddUserVariant2'
import { fetchIsUserFromBetaProduct } from '../../redux/actions/personaliseCourse'
import { useNavigate } from 'react-router-dom'
import './index.css'
import { useSearchParams } from "react-router-dom";
import LoginLogo from '../../components/Navbar/NavBarRight/LoginLogo'

const titles = [
    "Welcome To LearnTube,",
    "Time To Choose Your Free Course,",
    "Let’s Customise Your Experience,",
    "Let’s Customise Your Experience,",
    "Let’s Customise Your Experience,",
    "Let’s Customise Your Experience,"
]

const subtitles = [
    "Select the domain you are interested in",
    "Select the course you are interested in",
    "Help us to create a better experience",
    "Help us to create a better experience",
    "When Do You Generally Like To Learn?",
    "Help us to create a better experience",
]

const timings = [
    {
        id: 1,
        time: "Morning",
        data: "morning",
        icon: faCloudSun,
        color: '#F87318'
    },
    {
        id: 2,
        time: "Afternoon",
        data: "afternoon",
        icon: faSun,
        color: '#F5D403'
    },
    {
        id: 3,
        time: "Evening",
        data: "evening",
        icon: faMoon,
        color: '#5EA4FC'
    },
]

const NewOnboardingPage = () => {

    const userName = useSelector(store => store?.profileDetails?.name)
    const customisedSkill = useSelector(state => state.personaliseCourse?.customSkillSelected)
    const email = useSelector(store => store?.profileDetails?.email)
    const betaProductUser = useSelector(store => store?.personaliseCourse?.betaUsers)
   
    const [ step, setStep ] = useState(1)
    const [ searchValue, setSearchValue ] = useState("")
    const [allCourses, setAllCourses ] = useState([])
    const [ searchedResults, setSearchedResults ] = useState([])
    const [ isLoading, setIsLoading ] = useState([])
    const [ skillList, setSkillList ] = useState([])
    const [ isOnBoarded , setIsOnBoarded ] = useState(false)
    const [ goalClicked, setGoalClicked ] = useState(false)
    const [goalIndex, setGoalIndex ] = useState(0)
    const [ roleClicked, setRoleClicked ] = useState(false)
    const [ roleIndex, setRoleIndex ] = useState(0)
    const [ skillClicked, setSkillClicked ] = useState(false)
    const [ onBoardingSkillLoading, setOnBoardingSkillLoading ] = useState(false)
    const [ skillName, setSkillName ] = useState('')
    const [ roles, setRoles ] = useState([])
    const [ goals, setGoals ] = useState([])
    const [ userInterests, setUserInterests ] = useState({
        courseName: '',
        skillDetails: {},
        goal: '',
        role: '',
        timing: ''
    })
    const [ customSkillSelected, setCustomSkillSelected ] = useState(false)
    const [ selectedFromCoursePage, setSelectedFromCoursePage ] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const debouncedValue = useDebounce(searchValue, 300)
    const { width } = useWindowSize()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE, {
            distinct_id: email
        })
        setIsLoading(true)
        dispatch(getAllCourses((res) => {
            setAllCourses(res)
            setIsLoading(false)
        }))
        dispatch(fetchIsUserFromBetaProduct())
        dispatch({ type: RESET_PERSONALISE_QUESTIONS, payload: null })
        dispatch({ type: RESET_PERSONALISE_ANALYSIS, payload: null })
        dispatch({ type: RESET_PERSONALISE_MCQ_ANSWER, payload: null })
        dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: false })
        dispatch(checkUserAccess((successObj)=>{ setIsOnBoarded(successObj?.is_onboarded)}))
        dispatch(getGoalsAndRoles((successObj) => {
                const filteredGoals = (successObj?.data).filter(
                  (item) => item?.type === "goal"
                );
                const fileredRoles = (successObj?.data).filter(
                  (item) => item?.type === "role"
                );
    
                setRoles(fileredRoles);
                setGoals(filteredGoals);
              },
              (errObj) => {}
            )
          );
    }, [dispatch, email])
    
    useEffect(() => {
        dispatch(onboardingSearch(debouncedValue, (successObj) => {
            setSearchedResults(successObj)
        }))
    }, [debouncedValue, dispatch])

    const handleDomainSelection = (course_slug, course_name) => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_COURSE_SELECTED, {
            distinct_id: email
        })
        setStep((prev) => prev + 1)
        setIsLoading(true)
        setUserInterests({
            ...userInterests,
            courseName: course_name
        })
        dispatch(getAllSkills(course_slug, (result) => {
            setSkillList(result)
            setIsLoading(false)
        }))
    }

    const handleSkillSelection = (id, index) => {
        if (step === 3){
            Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_GOAL_SELECTED, {
                distinct_id: email
            })
            setGoalClicked(true)
            setGoalIndex(index + 1)
            setUserInterests({
                ...userInterests,
                goal: id
            })
            setTimeout(() => setStep((prev) => prev + 1), 2000)
            setTimeout(() => setGoalClicked(false), 2500)
        } else if (step === 4){
            Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_ROLE_SELECTED, {
                distinct_id: email
            })
            setRoleClicked(true)
            setRoleIndex(index + 1)
            setUserInterests({
                ...userInterests,
                role: id
            })
            setTimeout(() => setStep((prev) => prev + 1), 2000)
            setTimeout(() => setRoleClicked(false), 2500)
        } else if (step === 5){
            Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_TIME_SELECTED, {
                distinct_id: email
            })
            setOnBoardingSkillLoading(true)
            setUserInterests({
                ...userInterests,
                timing: id
            })
            dispatch(setOnboardingData(userInterests?.skillDetails?.id, id, userInterests?.goal, userInterests?.role, !isOnBoarded, customSkillSelected, (successObj) => {
                if (betaProductUser?.is_ninjacurate_user && betaProductUser?.ninjacurate_is_paid){
                    console.log("i was called")
                    if (customisedSkill){
                        if(searchParams.get("course")){
                            navigate(`/popular-course/${searchParams?.get("course")}`);
                          }
                          else{
                     navigate('/courses')}
                          
                    }else{
                        navigate(`/${successObj?.data?.course_slug}/${successObj?.data?.skill_slug}/${successObj?.data?.mskill_slug}/${successObj?.data?.id}`)
                    }
                }else{
                    setStep((prev) => prev + 1)
                }
                setOnBoardingSkillLoading(false)
            }))
        } else {
            Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
                distinct_id: email
            })
            setSkillName(id?.['skill-name'])
            setCustomSkillSelected(false)
            setSkillClicked(true)
            setUserInterests({
                ...userInterests,
                skillDetails: id
            })
            dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug }})
            setTimeout(() => setStep((prev) => prev + 1), 2000)
            setTimeout(() => setSkillClicked(false), 2500)
        }
        if (step === 1){
            setStep((prev) => prev + 1)
        }
    }

    const handleCustomSkillSelection = () => {
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_CUSTOM_SKILL_SELECTED, {
            distinct_id: email
        })
        setCustomSkillSelected(true)
        dispatch({ type: SET_CUSTOM_SKILL_SELECTED, payload: true })
        dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: debouncedValue, skill_slug: debouncedValue }})
        setUserInterests({
            ...userInterests,
            skillDetails: { 'id': 0,
                'skill-name': debouncedValue
            }
        })
        setSearchValue("")
        if (step === 1){
            setSelectedFromCoursePage(true)
            setStep(prev => prev + 2)
        }else{
            setSelectedFromCoursePage(false)
            setStep(prev => prev + 1)
        }
    }

    const handleSearchResult = (id) => {
        setSkillClicked(true)
        setSearchValue('')
        setCustomSkillSelected(false)
        Mixpanel.track(Constants.Mixpanel.NEW_ONBOARDING_PAGE_SKILL_SELECTED, {
            distinct_id: email
        })
    
        setSkillName(id?.['skill-name'])
        setUserInterests({
            ...userInterests,
            skillDetails: id
        })
        dispatch({ type: SET_PERSONALISE_COURSE_NAME, payload: { skill_name: id?.["skill-name"], skill_slug: id?.skill_slug }})
        if(step === 1){
            setSelectedFromCoursePage(true)
            setTimeout(() => setStep((prev) => prev + 2), 2000)
        }else{
            setSelectedFromCoursePage(false)
            setTimeout(() => setStep(prev => prev + 1), 2000)
        }
        setTimeout(() => setSkillClicked(false), 2500)
    }

    const handleBack = () => {
        if (step === 3 && selectedFromCoursePage){
            setStep(prev => prev - 2)
            setSelectedFromCoursePage(false)
        }else{
            setStep(prev => prev - 1)
        }
    }

    const newLearners = useCallback(() => {
        const time = new Date()
        const hours = time.getHours()
        const minutes = time.getMinutes()
        let maxLearners = hours.toString() + (minutes <= 9 ? "0" + minutes.toString() : minutes.toString())
        console.log(maxLearners)
        return Math.max(parseInt(maxLearners)+9, 171)
    }, [])
    
    return (
        (step <= 5 ? <div className='text-white w-full min-h-screen p-4 md:p-6 relative flex flex-col parent-radial-gradient-background' >
            {step > 1 ? <div className='bg-white absolute cursor-pointer z-50 w-6 h-6 top-8 left-8 flex justify-center items-center rounded-full' onClick={handleBack}>
                <FontAwesomeIcon icon={faArrowLeft} className='text-lg text-black font-semibold'/>
            </div> : null}
            <div className='w-full md:w-2/3 mx-auto flex-1 flex flex-col'>
                <div className='block pb-5'>
                    <Logo/>
                    <div className='mt-5'>
                        <h2 className='text-sm md:text-2xl text-center font-semibold'>{titles[step-1]} <span className='text-[#67CDEE]'>{userName?.split(" ")?.[0]}</span></h2>
                        <div className='flex justify-center items-center mt-1'>
                            <div className='w-[46px] mr-2'>
                                <ProgressBar
                                    bgcolor={"#54D15A"}
                                    progress={Math.floor(step) * 20}
                                    height={8}
                                />
                            </div>
                            <p className='text-xs md:text-base font-medium text-center'>Step {step}/{5}: {subtitles[step - 1]}</p>
                        </div>
                        {step < 3 ? <SearchBar
                            searchValue={searchValue}
                            setSearchValue={setSearchValue}
                            setStep={setStep}
                            handleCustomSkillSelection={handleCustomSkillSelection}
                        /> : null}
                    </div>
                </div>
                {debouncedValue ? (searchedResults?.length > 0 ?
                <div className=''>
                    {!skillClicked && <h3 className='text-xl font-bold mb-2'>Choose Course</h3>}
                    {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-10'>
                        {searchedResults?.map((item, index) => (
                            <div key={index} className={`bg-[#2D4F71] mb-2 flex items-center hover:opacity-70 py-2.5 px-2 rounded-lg ${userInterests?.skillDetails?.["skill-name"] === item?.["skill-name"] ? 'border-2 border-[#00C838]' : ''} cursor-pointer`} onClick={() => handleSearchResult(item)}>
                                <img src={item?.skill_thumbnail?.lesson_videoThumbnail} width={36} height={20} alt="video thumbnail" />
                                <p className='flex-1 text-sm font-semibold ml-3'>{item?.["skill-name"]}</p>
                                <FontAwesomeIcon icon={faChevronRight} className='text-lg mr-1'/>
                            </div>
                        ))}
                    </div> : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                        <p className='text-sm font-semibold'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                        <ClipLoader color='#1CB05E' size={20}/>
                    </div>}
                </div> : 
                <>
                    <h2 className='text-xl font-bold mb-2 mt-2'>Select Your Course</h2>
                    <div className='bg-[#2D4F71] flex items-center w-full md:w-1/2 py-2.5 rounded-lg px-2 cursor-pointer' onClick={() => handleCustomSkillSelection()}>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/brainstorming-94359.png?updatedAt=1688727493618" width={24} height={24} alt="brain icon" />
                        <p className='ml-2'>{debouncedValue}</p>
                    </div>
                </>) : step === 1 ? <div className=''>
                    {isLoading ? <Skeleton /> : 
                    <div>
                        {!skillClicked && <h3 className='text-xl font-bold mb-2'>Choose Category</h3>}
                        {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-10'>
                            {allCourses?.map((item, index) => (
                                <SingleList
                                    key={index} 
                                    name={item?.["course-name"]} 
                                    step={step}
                                    slug={item?.course_slug}
                                    imageLink={item?.course_icon?.url}  
                                    handleDomainSelection={handleDomainSelection}
                                    selected={userInterests?.courseName}
                                    index={index}
                                />
                            ))}
                        </div>  : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm font-semibold'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                    </div>}
                    </div>}
                </div> : 
                step === 2 ? <div>
                    {isLoading ? <Skeleton /> : 
                    <div>
                        {!skillClicked && <h3 className='text-xl font-bold mb-2'>Choose Course</h3>}
                        {!skillClicked ? <div className='grid md:grid-cols-2 md:gap-x-10'>
                            {skillList?.map((item, index) => (
                                <SingleList
                                    key={index}
                                    name={item?.["skill-name"]}
                                    step={step}
                                    slug={item}
                                    imageLink={item?.skill_thumbnail}
                                    handleDomainSelection={handleSkillSelection}
                                    selected={userInterests?.skillDetails?.["skill-name"]}
                                    index={index}
                                />
                            ))}
                        </div> : <div className='border-2 w-full mx-auto md:w-2/3 px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm font-semibold ml-0.5'><span className='text-[#00C1FF] font-bold'>{newLearners()} users</span> learning {skillName} this week</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>}
                    </div>}
                </div> : 
                step === 3 ? <div>
                    <h3 className='text-xl font-bold mb-2'>What Is Your Primary Goal Of Learning?</h3>
                    {!goalClicked ? <div className='grid md:grid-cols-2 md:gap-x-10'>
                        {goals?.map((item, index) => (
                            <SingleList
                                key={index}
                                name={item?.goal_name}
                                step={step}
                                slug={item?.goal_name}
                                imageLink={item?.goal_icon}
                                handleDomainSelection={handleSkillSelection}
                                selected={userInterests?.goal}
                                index={index}
                            />
                        ))}
                    </div> :
                    <div className='grid md:grid-cols-2 md:gap-x-10 gap-y-2'>
                        <div className={`border-2 ${goalIndex === 1 ? '' : 'opacity-0'} w-full mx-auto px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm font-semibold'><span className='text-[#00C1FF] md:font-bold'>74% learners</span> Got A Job Within 3 Months</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>
                        <div className={`border-2 ${goalIndex === 2 ? '' : 'opacity-0'} w-full mx-auto px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm'><span className='text-[#00C1FF] md:font-bold'>71% users</span> successfully switched careers</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>
                        <div className={`border-2 ${goalIndex === 3 ? '' : 'opacity-0'} w-full mx-auto px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm'>Users see <span className='text-[#00C1FF] md:font-bold'>62% increase</span> in profile views</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>
                        <div className={`border-2 ${goalIndex === 4 ? '' : 'opacity-0'} w-full mx-auto px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm'>Learners report <span className='text-[#00C1FF] md:font-bold'>43%</span> higher salaries</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>
                        <div className={`border-2 ${goalIndex === 5 ? '' : 'opacity-0'} w-full mx-auto px-2 self-center rounded-lg border-[#1CB05E] bg-[#2D4F71] flex justify-between h-[48px] items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-sm'><span className='text-[#00C1FF] md:font-bold'>91% users</span> acquired a new skill in 1 month</p>
                            <ClipLoader color='#1CB05E' size={20}/>
                        </div>
                    </div>}
                </div> : 
                step === 4 ? <div>
                    <h3 className='text-xl font-bold mb-2'>What Is Your Current Role?</h3>
                    {!roleClicked ? <div className='grid md:grid-cols-2 md:gap-x-10'>
                        {roles?.map((item, index) => (
                            <SingleList
                                key={index}
                                name={item?.goal_name}
                                step={step}
                                slug={item?.goal_name}
                                imageLink={item?.goal_icon}
                                handleDomainSelection={handleSkillSelection}
                                selected={userInterests?.role}
                                index={index}
                            />
                        ))}
                    </div> :
                    <div className='grid md:grid-cols-2 md:gap-x-10 gap-y-2'>
                        <div className={`border-2 ${roleIndex === 1 ? '' : 'opacity-0'} w-full mx-auto rounded-lg border-[#1CB05E] bg-[#2D4F71] flex h-[48px] justify-evenly md:justify-between md:px-2 items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-xs md:text-sm font-semibold text-center'><span className='text-[#00C1FF] md:font-bold'>71% chance </span> of getting hired by</p>
                            <div className='w-[61px] md:w-[70px] h-full mt-6 md:mt-5'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%209210.png?updatedAt=1695304229454" width={61} height={16} alt="company icon" className='w-full h-auto'/>
                            </div>
                            <ClipLoader color='#1CB05E' size={width > 768 ? 20 : 16}/>
                        </div>
                        <div className={`border-2 ${roleIndex === 2 ? '' : 'opacity-0'} w-full mx-auto rounded-lg border-[#1CB05E] bg-[#2D4F71] flex h-[48px] justify-evenly md:justify-between md:px-2 items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-xs md:text-sm font-semibold text-center'><span className='text-[#00C1FF] md:font-bold'>82% chance </span>of getting hired by</p>
                            <div className='w-[61px] md:w-[70px] h-full mt-6 md:mt-5'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%209210.png?updatedAt=1695304229454" width={61} height={16} alt="company images" className='w-full h-auto'/>
                            </div>
                            <ClipLoader color='#1CB05E' size={width > 768 ? 20 : 16}/>
                        </div>
                        <div className={`border-2 ${roleIndex === 3 ? '' : 'opacity-0'} w-full mx-auto rounded-lg border-[#1CB05E] bg-[#2D4F71] flex h-[48px] justify-evenly md:justify-between md:px-2 items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-xs md:text-sm font-semibold text-center'><span className='text-[#00C1FF] md:font-bold'>64% chance </span>of getting hired by</p>
                            <div className='w-[61px] md:w-[70px] h-full mt-6 md:mt-5'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/image%20533.png?updatedAt=1695304297436" width={61} height={16} alt="company images" className='w-full h-auto'/>
                            </div>
                            <ClipLoader color='#1CB05E' size={width > 768 ? 20 : 16}/>
                        </div>
                        <div className={`border-2 ${roleIndex === 4 ? '' : 'opacity-0'} w-full mx-auto rounded-lg border-[#1CB05E] bg-[#2D4F71] flex h-[48px] justify-evenly md:justify-between md:px-2 items-center`}>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Information%20Sign.png?updatedAt=1694601530388" width={20} height={20} alt="info icon" />
                            <p className='text-xs md:text-sm font-semibold text-center'><span className='text-[#00C1FF] md:font-bold'>74% chance </span>of getting hired by</p>
                            <div className='w-[61px] md:w-[70px] h-full mt-6 md:mt-5'>
                                <img src="https://assets.learntube.ai/files/Onboarding_Revamp/image%20533.png?updatedAt=1695304297436" width={61} height={16} alt="company images" className='w-full h-auto'/>
                            </div>
                            <ClipLoader color='#1CB05E' size={width > 768 ? 20 : 16}/>
                        </div>
                    </div>}
                </div> : 
                step === 5 ? <div className='w-full flex-1 flex flex-col items-center'>
                    {!onBoardingSkillLoading ?<><h3 className='text-xl font-bold mb-2'>When Do You Generally Like To Learn?</h3>
                    {timings?.map((item, index) => (<div key={index} className={`bg-[#2D4F71] w-full md:w-[400px] mb-2 flex items-center py-2.5 px-2 rounded-lg cursor-pointer ${userInterests?.timing === item?.time ? 'opacity-80 border-2 border-[#00C838]' : ''}`} onClick={() => handleSkillSelection(item?.data)}>
                        <FontAwesomeIcon icon={item?.icon} color={item?.color} className='text-2xl'/>
                        <p className='flex-1 text-sm font-semibold ml-3'>{item?.time}</p>
                        <FontAwesomeIcon icon={faChevronRight} className='text-lg mr-1'/>
                    </div>
                    ))}</> : <div className='flex-1 flex items-center justify-center'>
                    <SyncLoader color='#1CB05E' size={15} className='mt-8' />
                </div>}
                </div> : null}
            </div>
        </div> : 
        // userId % 2 === 0 ? 
        // <PersonalisedSectionEvenUser
        //     step={step}
        //     userName={userName}
        //     subtitles={subtitles}
        //     titles={titles}
        //     handleBack={handleBack}
        //     userInterests={userInterests}
        // /> :
        <PersonalisedOddUserVariant2
            userInterests={userInterests}
            userName={userName}
            customSkillSelected={customSkillSelected}
        />)
    )
}

export default NewOnboardingPage